module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2",
      "xml:lang": "en-GB"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ABA_Also_by_A_head ParaOverride-2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Also by Va")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("l McDermid")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("A Place of")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(" Execution")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Killing t")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("he Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Gr")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ave Tattoo")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Trick o")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("f the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Vanis")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("hing Point")])]), _vm._v(" "), _c('p', {
    staticClass: "ABB_Also_by_B_head ParaOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("tony hill/carol jor")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("dan novels")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Mermai")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ds Singing")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Wire in")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(" the Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e La")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("st")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Temptation")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Torment")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(" of Others")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Beneath th")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Bleeding")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Fever o")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("f the Bone")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e R")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("etribution")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cros")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("s and Burn")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Splinter t")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("he Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Insidi")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ous Intent")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("How the ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Dead Speak")])]), _vm._v(" "), _c('p', {
    staticClass: "ABB_Also_by_B_head ParaOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("karen pi")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("rie novels")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Di")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ant Echo")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("A Dar")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ker Domain")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Th")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e Ske")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("leton Road")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Out")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(" of Bounds")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Bro")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ken Ground")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Still Li")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("fe")])])]), _vm._v(" "), _c('p', {
    staticClass: "ABB_Also_by_B_head ParaOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("lindsay gor")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("don novels")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Report ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("r Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Com")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("mon Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Fin")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("al Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Union Jack")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Booked ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("r Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Ho")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("st")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("age")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(" to Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "ABB_Also_by_B_head ParaOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("kate branni")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("gan novels")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Dead Beat")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Kick Back")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Crack Down")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("C")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("lean Break")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Blue Genes")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("tar Struck")])]), _vm._v(" "), _c('p', {
    staticClass: "ABB_Also_by_B_head ParaOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("short ")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("st")]), _c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ory c")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ollections")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Stranded (")]), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("e")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3 CharOverride-1",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("book only")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ABB_Also_by_B_head ParaOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("n")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("on")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ction")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("A Suitable Job ")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("f")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("o")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("r a Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Forensics")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("M")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("y Scotland")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d6ea52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-1.vue
// module id = 66
// module chunks = 0